import axios from "axios";
import Aes from "./Aes2.js";
import store from '../store/index';
import iView from 'view-design'

//手相接口调用失败信息
let errorInfo = {
  1: '请求中未包含params参数',
  2: "params字符串解密失败",
  3: "params载入失败，json格式错误",
  4: "params实例中的appId、timestamp、picId、apiUrl、userdata键值读取错误",
  5: "预测结果字符串加密失败",
  6: "把预测结果post到慈脉API时发生错误",
  7: "慈脉API返回success为False",
  8: "请求中未包含multipartFiles",
  9: "慈脉API的返回中未包含success参数",
  10: "算法预测失败、判定为异常样本",
}


// 创建 axios 实例
const service = axios.create({
  timeout: 50000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    /*     
    let urls = config.url.split("/");
    let name = urls[urls.length - 1]
    console.log("--->", name);
    if (window.cancelList[name] && !["getWideUseList", "getSungoData", "getFeedbackMessagePatientList", "waitReplyList", "getAverageCourse"].includes(name)) {
      window.cancelList[name]();
    }
    // 配置当前的cancelToken 保存cancel
    config.cancelToken = new CancelToken((c) => {
      window.cancelList[name] = c;
    }) */


    // 不显视加载动画提示
    if (!config.data || !config.data.notLoading) {
      store.commit('openSpin')
    }

    if (
      config.headers["Content-Type"] != "multipart/form-data" &&
      !config.data?.isNotEncrypt
    ) {
      config.data = Aes.encrypt(config.data);
    }
    var token = store.getters.token || [];
    config.headers.Authorization = token[0] || "";

    config.baseURL = window.config.newapi;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    store.commit('closeSpin')
    let res = response.data;
    let url,
      api = "";
    if (response.config.url) {
      url = response.config.url.split("/");
      api = url[url.length - 1];
    }

    if (res.success || res.warn_msg === '成功' || Number(res.infcode) === 0 || res.msg == "success！") {
      if (res.result) {
        try {
          if (typeof (res.result) == 'string') res.result = Aes.decrypt(res.result)
        } catch (error) { }
      } else {
        if (res.encrypt) res.result = Aes.decrypt(res.encrypt);
      }
      if (window.config.debug) {
        console.log(api, JSON.parse(JSON.stringify(res)));
      }
      return res;
    } else {
      let message = res.err_msg || res.error?.messages || "";
      try {
        message = Aes.decrypt(message);
      } catch (error) { }
      if (res.error && res.error.code == 11) {
        iView.Message.error(message + ", 即将跳转到登录页！");
        setTimeout(() => {
          store.commit("logOut");
        }, 3000);
      } else if (res.info) {
        iView.Message.error(errorInfo[res.info] || "系统出错");
      } else {
        if (response.status == 503) {
          message = '接口没有通！ 错误码：' + response.status
        }
        iView.Message.error(message || "系统出错");
      }
      return Promise.reject(new Error(message || "Error"));
    }
  },
  (error) => {
    store.commit('closeSpin')

    if (error.response.data) {
      let { code, msg } = error.response.data;
      // token 过期,重新登录
      if (code === "A0230") {

        this.$Modal.confirm({
          title: "提示",
          content: "当前页面已失效，请重新登录",
          onOk: () => {
            localStorage.clear();
            window.location.href = "/";
          }
        })
      } else {
        if (error.response.status == 503) {
          msg = '接口没有通！ 错误码：' + error.response.status
        }
        iView.Message.error(msg || "系统出错");
      }
    }
    return Promise.reject(error.message);
  }
);

// 导出 axios 实例
export default service;
